import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-link">&copy; <Link to="/">SearchGull</Link> </div>
      <div className="footer-link"><Link to="/settings">Settings</Link> </div>
      <div className="footer-link"><Link to="/about">About</Link> </div>
    </div>
  )
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer.js